import {request} from '../jslib/request'
const BASE_REQUEST = '/tms/sysCustomerInvoice'
const BASE_REQUEST_CONTACT = '/tms/sysCustomerInvoicecontacts'

export function getAllInvoice() {
  return request({
    url:`${BASE_REQUEST}/getAllInvoice`
  })
}

export function getInvoiceByCusId(cusSupId) {
  return request({
    url:`${BASE_REQUEST}/getInvoiceByCusId`,
    data: {
      cusSupId:cusSupId
    }
  })
}

export function getInvoiceBySupId(cusSupId) {
  return request({
    url:`${BASE_REQUEST}/getInvoiceBySupId`,
    data: {
      cusSupId:cusSupId
    }
  })
}


export function saveInvoice(obj) {
  return request({
    url:`${BASE_REQUEST}/saveInvoice`,
    data: obj
  })
}

export function saveInvoiceContact(obj) {
  return request({
    url:`${BASE_REQUEST_CONTACT}/saveInvoiceContact`,
    data: obj
  })
}
